<template>
    <div id="app">
        <header class="banner">
            <div class="tw-container tw-pt-10 tw-relative md:tw-pt-10">
                <LanguageSwitcher />
                <img src="~@/assets/img/kwanko.svg" alt="kwanko logo" class="tw-absolute tw-top-0 kwanko-flag">
                <img src="~@/assets/img/blackfriday-logo.svg" class="bf-logo tw-relative">

                <div class="banner-download-section tw-w-full tw-bg-white tw-mt-12" v-if="$route.name == 'Home'">
                    <h1>{{$t('page.header.title')}}</h1>
                    <h2>{{$t('page.header.subtitle')}}</h2>
                    <div class="tw-flex tw-justify-center tw-content-center tw-text-center tw-items-center tw-w-full btn-container">
                        <router-link :to="`/${this.$i18n.locale}/proposition`"><button class="btn-form-page header-download tw-text-white"><h2 class="tw-text-white">{{$t('page.header.button')}}</h2></button></router-link>
                    </div>
                </div>
            </div>
        </header>

        <!-- This will be reaplced by the view defined in the router -->
        <router-view></router-view>

        <footer class="tw-py-8 md:tw-py-6 tw-text-white">
            <div class="tw-container tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center md:tw-justify-between">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-mb-10 md:tw-mb-0">
                    <img src="./assets/img/logo_k_footer.svg" alt="Kwanko">
                    <div>
                        <p>
                            Copyright <span class="year"></span> - Kwanko | <a href="https://www.kwanko.com/gdpr/privacy-policy/" target="_blank" class="hover:tw-underline">Privacy Policy</a> | <a href="https://www.kwanko.com/tc/" target="_blank" class="hover:tw-underline">Terms & Conditions</a>
                        </p>
                    </div>
                </div>
                <div class=" tw-flex tw-items-center">
                    <a href="https://www.facebook.com/KwankoGroupe/" target="_blank">
                        <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-mx-2 contacts">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10.024" height="18.541" viewBox="0 0 10.024 18.541"><path id="Forma_1" data-name="Forma 1" d="M26.919,12.243l-2.407-.012a4.218,4.218,0,0,0-4.445,3.979,4.132,4.132,0,0,0,.008.587v2.1H17.657a.381.381,0,0,0-.387.374v3.054a.38.38,0,0,0,.385.375h2.421V30.39a.37.37,0,0,0,.366.375H23.6a.379.379,0,0,0,.387-.373V22.7H26.8a.371.371,0,0,0,.376-.366V19.274a.414.414,0,0,0-.106-.27.369.369,0,0,0-.27-.106H23.983V17.114c0-.7.194-1.3.786-1.3.212,0,.356,0,.529,0h1.62a.371.371,0,0,0,.376-.366V12.618a.37.37,0,0,0-.366-.375Z" transform="translate(-17.27 -12.224)" fill="#fff" fill-rule="evenodd"/></svg>
                        </div>
                    </a>
                    <a href="https://twitter.com/KwankoGroup" target="_blank">
                        <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-mx-2 contacts">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18.808" height="15.853" viewBox="0 0 18.808 15.853"><path id="Forma_1" data-name="Forma 1" d="M30.984,15.8a7.456,7.456,0,0,1-2.219.628,3.967,3.967,0,0,0,1.7-2.207,7.7,7.7,0,0,1-2.445.973,3.81,3.81,0,0,0-2.812-1.27,3.927,3.927,0,0,0-3.857,3.995v0a4.625,4.625,0,0,0,.084.913,10.81,10.81,0,0,1-7.951-4.188,4.169,4.169,0,0,0-.522,2.029A4.065,4.065,0,0,0,14.668,20a3.716,3.716,0,0,1-1.745-.5v.048a3.979,3.979,0,0,0,3.1,3.928,3.536,3.536,0,0,1-1.009.13,3,3,0,0,1-.735-.071,3.915,3.915,0,0,0,3.607,2.788A7.568,7.568,0,0,1,13.1,28.032a5.907,5.907,0,0,1-.926-.06,10.535,10.535,0,0,0,5.922,1.8c7.1,0,10.976-6.1,10.976-11.38,0-.178-.012-.356-.024-.522A7.682,7.682,0,0,0,30.984,15.8Z" transform="translate(-12.176 -13.923)" fill="#fff" fill-rule="evenodd"/></svg>
                        </div>
                    </a>
                    <a href="https://www.linkedin.com/company/kwanko/" target="_blank">
                        <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-mx-2 contacts">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15.747" height="15.679" viewBox="0 0 15.747 15.679"><path id="Forma_1" data-name="Forma 1" d="M29.609,23.429V29.5h-3.38V23.828c0-1.42-.481-2.382-1.7-2.382a1.851,1.851,0,0,0-1.737,1.279,2.379,2.379,0,0,0-.117.857V29.5H19.305s.047-9.587,0-10.585h3.368v1.5c0,.012-.012.024-.012.035h.012v-.035a3.366,3.366,0,0,1,3.051-1.748C27.943,18.665,29.609,20.178,29.609,23.429ZM15.774,13.819a1.826,1.826,0,0,0-.17,3.648c.041,0,.082,0,.123,0h.024a1.826,1.826,0,1,0,.153-3.648c-.043,0-.086,0-.129,0ZM14.06,29.5h3.38V18.911H14.06Z" transform="translate(-13.863 -13.817)" fill="#fff" fill-rule="evenodd"/></svg>
                        </div>
                    </a>
                    <a href="https://www.instagram.com/kwankogroup/" target="_blank">
                        <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-mx-2 contacts">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20.033" height="19.951" viewBox="0 0 20.033 19.951"><path id="Forma_1" data-name="Forma 1" d="M26.4,11.933H17.426a5.524,5.524,0,0,0-5.528,5.5v8.943a5.516,5.516,0,0,0,5.528,5.5H26.4a5.516,5.516,0,0,0,5.528-5.5V17.437A5.524,5.524,0,0,0,26.4,11.933ZM30.159,26.38A3.755,3.755,0,0,1,26.4,30.112H17.426a3.755,3.755,0,0,1-3.755-3.732V17.437A3.755,3.755,0,0,1,17.426,13.7H26.4a3.755,3.755,0,0,1,3.755,3.733V26.38Zm-8.25-9.612a5.141,5.141,0,1,0,5.164,5.141,5.141,5.141,0,0,0-5.164-5.141Zm0,8.509A3.368,3.368,0,1,1,25.3,21.909a3.369,3.369,0,0,1-3.392,3.368h0ZM27.3,15.266a1.366,1.366,0,0,0-.928.375,1.319,1.319,0,0,0,0,1.843,1.366,1.366,0,0,0,.928.375,1.312,1.312,0,0,0,.915-.375,1.291,1.291,0,0,0,.017-1.826l-.017-.017a1.32,1.32,0,0,0-.915-.375Z" transform="translate(-11.898 -11.933)" fill="#fff" fill-rule="evenodd"/></svg>
                        </div>
                    </a>
                    <a href="https://www.youtube.com/channel/UC6LicX0T6rb3JO5BA-4BbTQ" target="_blank">
                        <div class="tw-flex tw-items-center tw-justify-center tw-rounded-full tw-mx-2 contacts">
                            <svg xmlns="http://www.w3.org/2000/svg" width="21.819" height="13.907" viewBox="0 0 21.819 13.907"><path id="Forma_1" data-name="Forma 1" d="M31.407,16.55a2.581,2.581,0,0,0-2.553-1.226c-1.3-.08-4.592-.114-7.432-.114s-6.144.035-7.445.114a2.592,2.592,0,0,0-2.553,1.226c-.609.974-.918,2.658-.918,5.613h0v.012c0,2.944.309,4.628.918,5.6A2.61,2.61,0,0,0,13.978,29c1.3.08,4.593.114,7.445.114s6.132-.035,7.444-.114a2.59,2.59,0,0,0,2.541-1.226c.609-.974.919-2.657.919-5.6v-.012h0C32.326,19.208,32.016,17.524,31.407,16.55ZM18.691,25.955V18.372l6.824,3.792Z" transform="translate(-10.507 -15.21)" fill="#fff" fill-rule="evenodd"/></svg>
                        </div>
                    </a>
                </div>
            </div>
        </footer>

        <ModalContainer :class="{'tw-opacity-0 tw-pointer-events-none' : !$store.getters.openModals }">
            <Terms/>
        </ModalContainer>

        <Clarity/>
    </div>
</template>

<script>
import axios from 'axios';
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import Clarity from '@/components/Clarity.vue';

export default {
    components: {
        KwPixel,
        Clarity,
        ModalContainer,
        Terms,
        LanguageSwitcher,
    },
    data() {
        return {
            total: '',
            seconds: '',
            minutes: '',
            hours: '',
            days: '',
        };
    },
    created() {
        switch(this.$i18n.locale) {
            case 'en':
                document.documentElement.lang = 'en';
                break;
            case 'fr':
                document.documentElement.lang = 'fr';
                break;
            case 'de':
                document.documentElement.lang = 'de';
                break;
            case 'pt':
                document.documentElement.lang = 'pt';
                break;
            default:
                break;
        }

        const endtime = 'November 27 2020 00:00:00 GMT+0100';
        setInterval(() => {
            this.total = Date.parse(endtime) - Date.parse(new Date());
            this.seconds = ((Math.floor((this.total / 1000) % 60) < 10 ? '0' : '') + Math.floor((this.total / 1000) % 60)).toString();
            this.minutes = (Math.floor((this.total / 1000 / 60) % 60) < 10 ? '0' : '') + Math.floor((this.total / 1000 / 60) % 60).toString();
            this.hours = (Math.floor((this.total / (1000 * 60 * 60)) % 24) < 10 ? '0' : '') + Math.floor((this.total / (1000 * 60 * 60)) % 24).toString();
            this.days = (Math.floor(this.total / (1000 * 60 * 60 * 24)) < 10 ? '0' : '') + Math.floor(this.total / (1000 * 60 * 60 * 24)).toString();
        }, 1000);

        const data = {
            url: window.location.hostname,
            pubid: this.$route.query.pubid || null,
            utm_source: this.$route.query.utm_source || null,
            utm_campaign: this.$route.query.utm_campaign || null,
            utm_medium: this.$route.query.utm_medium || null,
            utm_content: this.$route.query.utm_content || null,
            utm_term: this.$route.query.utm_term || null,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => {
                console.log(error.response.data);
            });
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        document.querySelector('.year').innerHTML = new Date().getFullYear();
    },
};
</script>
<style>

</style>
